import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { UserListItem } from '@/services/reparoly/usersApi';

export type TechniciansState = {
  items: UserListItem[];
  lastFetchedAt: string | null;
};

const initialState: TechniciansState = {
  items: [],
  lastFetchedAt: null,
};

const techniciansSlice = createSlice({
  name: 'technicians',
  initialState,
  reducers: {
    setTechnicians(state, action: PayloadAction<{ items: UserListItem[]; fetchedAt?: string }>) {
      state.items = action.payload.items || [];
      state.lastFetchedAt = action.payload.fetchedAt || new Date().toISOString();
    },
    resetTechnicians: () => initialState,
  },
});

export const { setTechnicians, resetTechnicians } = techniciansSlice.actions;
export default techniciansSlice.reducer;
